import React, { useEffect, useState } from "react";
import { ArrowLeft, BadgePercent, Hash, Loader2 } from "lucide-react";
import swal from "sweetalert";
import {
  fetchDocumentPreferences,
  isPreferenceEnabled,
  updateDocumentPreference,
} from "../../../utils/documentPreferences";
import "./Preferences.css";

const PreferenceToggle = ({ icon, title, description, checked, disabled, onChange }) => (
  <div className="document-preference-row">
    <span className="document-preference-icon">{icon}</span>
    <div className="document-preference-copy">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
    <label className="document-preference-switch">
      <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
      <span aria-hidden="true" />
      <em>{checked ? "On" : "Off"}</em>
    </label>
  </div>
);

const Preferences = ({ navigation }) => {
  const [values, setValues] = useState({ discountCheck: false, hsnCheck: false });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState("");

  useEffect(() => {
    fetchDocumentPreferences()
      .then((data) => setValues({
        discountCheck: isPreferenceEnabled(data.discountCheck),
        hsnCheck: isPreferenceEnabled(data.hsnCheck),
      }))
      .catch((error) => swal({ icon: "error", title: error.message }))
      .finally(() => setLoading(false));
  }, []);

  const toggle = async (key) => {
    const nextValue = !values[key];
    setSaving(key);
    try {
      await updateDocumentPreference(key, nextValue);
      setValues((current) => ({ ...current, [key]: nextValue }));
      swal({ icon: "success", title: "Preference updated" });
    } catch (error) {
      swal({ icon: "error", title: error.message });
    } finally {
      setSaving("");
    }
  };

  return (
    <main className="document-preferences-page">
      <button className="document-preferences-back" type="button" onClick={() => navigation.navigate("Setting")}>
        <ArrowLeft size={18} /> Settings
      </button>
      <header>
        <p>Preferences</p>
        <h1>Document Column Preferences</h1>
        <span>These organization-level settings control columns across sales, purchase, document preview, and printing screens.</span>
      </header>
      <section className="document-preferences-card">
        {loading ? (
          <div className="document-preferences-loading"><Loader2 size={22} /> Loading preferences…</div>
        ) : (
          <>
            <PreferenceToggle
              icon={<BadgePercent size={22} />}
              title="Discount"
              description="Show discount fields and columns on document item tables."
              checked={values.discountCheck}
              disabled={Boolean(saving)}
              onChange={() => toggle("discountCheck")}
            />
            <PreferenceToggle
              icon={<Hash size={22} />}
              title="HSN / SAC"
              description="Show HSN/SAC fields and columns across applicable documents."
              checked={values.hsnCheck}
              disabled={Boolean(saving)}
              onChange={() => toggle("hsnCheck")}
            />
          </>
        )}
      </section>
    </main>
  );
};

export default Preferences;
